import { render, staticRenderFns } from "./EditCollege.vue?vue&type=template&id=60e38c5a&scoped=true"
import script from "./EditCollege.vue?vue&type=script&lang=js"
export * from "./EditCollege.vue?vue&type=script&lang=js"
import style0 from "./EditCollege.vue?vue&type=style&index=0&id=60e38c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e38c5a",
  null
  
)

export default component.exports